import { useMutation, useQueryClient } from '@tanstack/react-query';
import { countryApi } from '../api/country.api';
import { countryKeys } from '../api/country.keys';
import toast from 'react-hot-toast';
import type { AxiosError } from 'axios';
import type { ApiErrorResponse, CountryFormData } from '@/shared/types';

export function useCreateCountry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CountryFormData) => countryApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: countryKeys.all });
      toast.success('Country created');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to create');
    },
  });
}

export function useUpdateCountry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: CountryFormData }) =>
      countryApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: countryKeys.all });
      toast.success('Country updated');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteCountry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => countryApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: countryKeys.all });
      toast.success('Country deleted');
    },
    onError: (err: AxiosError<ApiErrorResponse>) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
